import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CdnPathPipe, EntitiesPipe } from '@uc/utilities';
import { Product } from '@uc/shared/data-models';
import { VisitWebsiteBtnComponent } from '@web/shared/ui';
@Component({
	selector: 'uc-university-section-card',
	templateUrl: './university-section-card.component.html',
	imports: [CdnPathPipe, EntitiesPipe, VisitWebsiteBtnComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversitySectionCardComponent {
	uniName = input.required<string>();
	componentName = input.required<string>();
	uniId = input<number | null>(null);
	name = input<string>('');
	description = input<string>('');
	image = input<string | null>();
	externalUrl = input<string>();
	product = input<Product | null>(null);
	ugSearchOrderPosition = input.required<number | null>();
}
